import * as React from 'react'
import { useTranslation } from '../../../hooks/useTranslation'
import { ServiceTypeCell } from './ServiceTypeCell'
import { DateCell } from './DateCell'
import { AttachmentCell } from './AttachmentCell'
import { DetailsCell } from './DetailsCell'
import { MeetingDateCell } from './MeetingDateCell'

export const columns = [
  {
    accessorKey: 'type',
    header: (props) => <TableHeader {...props} />,
    cell: (props) => <ServiceTypeCell {...props} />,
    enableSorting: false,
    filterFn: (row, _columnId, filterValue) => {
      return !filterValue || filterValue === row.original.type
    },
  },
  {
    accessorKey: 'completed_at',
    header: (props) => <TableHeader {...props} />,
    cell: (props) => <DateCell {...props} />,
    enableSorting: true,
  },
  {
    accessorKey: 'meeting_date',
    header: (props) => <TableHeader {...props} />,
    cell: (props) => <MeetingDateCell {...props} />,
    enableSorting: true,
  },
  {
    accessorKey: 'attachment',
    header: (props) => <TableHeader {...props} />,
    cell: (props) => <AttachmentCell {...props} />,
    enableSorting: false,
  },
  {
    accessorKey: 'details',
    header: (props) => <BlankHeader {...props} />,
    cell: (props) => <DetailsCell {...props} />,
    enableSorting: false,
  },
]

function TableHeader({ column }) {
  const { t } = useTranslation('TableHeader')

  return <div className="subtitle">{t(column.id)}</div>
}

function BlankHeader({ column }) {
  const { t } = useTranslation('TableHeader')
  return (
    <div className="font-roboto">
      <span className="sr-only">{t(column.id)}</span>
    </div>
  )
}
